export const printId = 'print-area';

export const LABEL_SIZE = {
  small: 'LABEL_SIZE_SMALL',
  large: 'LABEL_SIZE_LARGE',
};
